import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const HeaderLink = ({ link, title, icon: Icon, extraClasses = '', isMobile = false, isActive = false, onClick }) => {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
            return;
        }
        // ... existing click handling
    };

        if (isMobile) {
            return (
                <Link
                    to={link}
                    aria-current={isActive ? 'page' : undefined}
                    className={`merch-font flex items-center gap-3 border-l-2 px-4 py-2.5 text-[20px] uppercase transition-colors ${
                        isActive
                            ? 'border-[#aade00] bg-[#aade00]/10 text-[#aade00]'
                            : 'border-transparent text-white/86 hover:bg-white/5 hover:text-[#aade00]'
                    }`}
                    onClick={handleClick}
                >
                    {Icon && <Icon className={isActive ? 'text-[#aade00]' : 'text-white/45'} />}
                    <span>{title}</span>
                </Link>
            );
        }

    return (
        <Link
            to={link}
            className={`inline-flex justify-center items-center gap-x-2 font-medium text-[12px] text-gray-800 hover:text-neutral-500 focus:outline-none focus:text-neutral-500 dark:text-neutral-200 dark:hover:text-neutral-500 dark:focus:text-neutral-500 ${extraClasses} hidden lg:inline-block`}
            onClick={handleClick}
        >
            {title}
        </Link>
    );
};

HeaderLink.propTypes = {
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.elementType,
    extraClasses: PropTypes.string,
    isMobile: PropTypes.bool,
    isActive: PropTypes.bool,
    onClick: PropTypes.func
};

export default HeaderLink;
